<template>
  <div v-if="userProfile && !isLoading2">
    <div class="section">
      <div class="columns is-centered is-centered">
        <div class="column is-11">
          <validation-observer
            ref="profile-fields"
            tag="form"
          >
            <profile
              v-bind="{ type: 'user', formTitle: 'Edit Profile', formDesc: 'Your profile information is used when starting a new filing.', showEmail: true }"
              @profile="userProfile = $event"
            />
          </validation-observer>
          <positions
            v-bind="{ type: 'user' }"
            @positions="positions = $event"
            @hasPositions="hasPositions = $event"
            @hasPrimaryPosition="hasPrimaryPosition = $event"
            @hasPositionsReady="hasPositionsReady = $event"
          />
          <statement-requirements
            v-if="componentAccess('statement-requirements', 'view')"
            :read-only="!componentAccess('statement-requirements', 'edit')"
            v-bind="{ type: 'user', required: false }"
            @requiredStatements="requiredStatements = $event"
          />
          <system-access
            :read-only="!componentAccess('system-access', 'edit')"
            v-bind="{ type: 'user' }"
            @systemAccessRoles="sysAccessRoles = $event"
            @systemAccessHasRoles="sysAccessHasRoles = $event"
          />
          <dept-access
            v-if="deptAccessView"
            v-bind="{ type: 'user' }"
            :read-only="!deptAccessEdit"
            @deptAccess="deptAccess = $event"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column has-text-centered">
          <button
            id="update-btn"
            type="button"
            class="button is-primary"
            :class="isSaving ? 'is-loading' : ''"
            :disabled="isSaving"
            @click="saveAndContinue"
          >
            Update Profile
          </button>
        </div>
      </div>
      <hr>
      <update-password />
    </div>
  </div>
</template>
<script>
import Profile from '@/components/Profile';
import Positions from '@/components/Positions';
import UpdatePassword from '@/components/UpdatePassword';
import { filerScreenHelpers } from '@/mixins/filerScreen';
import { controlValueHelpers } from '@/mixins/controlValue';
import StatementRequirements from '@/components/StatementRequirements';
import SystemAccess from '@/components/SystemAccess';
import DeptAccess from '@/components/DeptAccess';

export default {
  name: 'User',
  components: {
    Profile,
    Positions,
    UpdatePassword,
    StatementRequirements,
    SystemAccess,
    DeptAccess,
  },
  mixins: [
    filerScreenHelpers,
    controlValueHelpers,
  ],
  data() {
    return {
      pass: 0,
      userProfile: {},
      isSaving: false,
      positions: [],
      hasPositions: false,
      hasPrimaryPosition: true,
    };
  },
  computed: {
    deptAccessView () {
      return this.componentAccess('dept-access', 'view') && this.sysAccessRoles.deptHead === 'Y';
    },
    deptAccessEdit () {
      return this.componentAccess('dept-access', 'edit') && this.sysAccessRoles.deptHead === 'Y';
    },
  },
  async created () {
    this.$store.commit('loading', false);
  },
  methods: {
    componentAccess (component, type) {
      let access = {
        view: [],
        edit: [],
      };

      if (this.userProfile.sysAdmin === 'Y') {
        access.view.push('statement-requirements');
        access.view.push('system-access');
        access.view.push('user-access');
      }
      if (this.userProfile.deptHead === 'Y') {
        access.view.push('statement-requirements');
        access.view.push('system-access');
        access.view.push('dept-access');
      }
      if (this.userProfile.filer === 'Y') {
        access.view.push('statement-requirements');
      }

      return access[type].includes(component);
    },
    async saveAndContinue () {
      let isValidProfile = await this.$refs['profile-fields'].validate();

      this.isSaving = true;

      if (
        !isValidProfile ||
        !this.hasPositions ||
        !this.hasPrimaryPosition) {
        let warnings = [];
        warnings.push("There are some validation issues.");
        if (!this.hasPrimaryPosition) {
          warnings.push("At least 1 primary position is required. Please edit positions and identify the \"Primary Position\".");
        }
        warnings.push("Please review your information and try again.");
        this.$warning(warnings.join(' '));
        this.isSaving = false;
        return false;
      }

      let promises = [];

      promises.push(this.$store.dispatch('user/updateUserProfile', { fields: this.userProfile, userId: this.userProfile.id }));
      promises.push(this.$store.dispatch('user/saveUserPositions', {
        positions: this.positions,
        userId: this.userProfile.id,
      }));

      Promise.all(promises).then(() => {
        this.isSaving = false;
        this.$success('User profile updated!');
      });

    },
    updatePositions (positions) {
      this.positions = positions;
    },
  },
};
</script>
